import { Divider, Flex, Select, Typography } from 'antd';
import styled from 'styled-components';

export const HeaderWrapper = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
  flex: 1,
})``;

export const FileNameText = styled(Typography.Text)`
  display: inline-block;
  width: 100%;
`;

export const FileNameContainer = styled(Flex)`
  width: 100%;
  overflow: hidden;
`;

export const SpacerStyled = styled.div`
  height: 16px;
`;

export const StyledDivider = styled(Divider)`
  margin: 20px 0;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  max-width: 100%;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const PrivacyPolicyWrapper = styled(Flex).attrs({
  vertical: true,
  gap: 4,
})``;
